import { ReactNode } from 'react';
import { Box } from '@planitgeo/treeplotter-ui-library';

type LayoutBoxProps = {
  children: ReactNode;
};

export default function LayoutBox({ children }: LayoutBoxProps) {
  return (
    <Box
      sx={{
        minHeight: { lg: 1 },
      }}
    >
      {children}
    </Box>
  );
}
